import { Link } from 'react-router-dom';
import { BsShareFill } from "react-icons/bs";
import { MdOutlineWatchLater } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { ImTarget } from "react-icons/im";
import config from '../config';

const ProductItem = ({ id, slug, thumbnail_image, name, description, raise_amount, end_date, campaing_type, order_detail_count }) => {

  return (
    <div className="col-sm-6 common-gap col-xl-4">

      <div className="product-list campaign-card h-100 card border-0  position-relative">
        {/* Tax Benefit Tag */}
        {/* {taxBenefit && <span className="tax-benefit-badge">Tax Benefit</span>} */}
        <span className='tax-benefit-badge'>Tax Benefit</span>
        <div className="campaing_image position-relative">
          {/* Product Image */}
          <Link to={`/product/${slug}`}>
          <img
            src={thumbnail_image}
            alt={name}
            className="product-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = config.defaultImage;
            }}
          />
        </Link>
          <div className="share-btn">
            <BsShareFill /></div>
        </div>
        {/* Product Content */}
        <div className="product-details card-body">
          <Link to={`/product/${slug}`}><h5 className="product-title card-title">{name}</h5></Link>




          {/* Time Left */}
          <div className="product-meta icon-box d-flex justify-content-between">
            <span className="product-time hours-icon">
              <MdOutlineWatchLater /> 1 hours left
            </span>


            {/* Sponsors */}
            <span className="product-sponsors hours-icon">
              <FaUsers /> {order_detail_count} Sponsors
            </span>
          </div>
          <div className="progress my-2 p-0">
            <div className="progress progress-bar bg-danger" style={{ width: `${(5 / 100) * 100}%` }}>
            </div>
          </div>

          {/* Target Progress */}
          <div className="product-target">
            <span className="target-title">
              <ImTarget /> <b>Target: </b>
            </span>
            <span className="target-progress">
              {/* {target.completed} left out of {target.total} */}
              {5} left out of{100}
            </span>

            {/* <div class="progress my-2 p-0">
               <div class="progress-bar bg-danger" role="progressbar" style="width: 40%;" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
                </div> */}

          </div>
        </div>
        <div className="mt-auto pb-4">
          <Link className='btn donate-button d-block mx-auto' to={`/product/${slug}`}>Donate Now</Link>
        </div>

      </div>
    </div>

  )
}

export default ProductItem
